<header [class.fixed-top]="isSticky" [class.scrolled]="isSticky">
  <nav class="navbar navbar-expand-lg">
    <div class="container">
      <div>
        <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbar-content" aria-label="Toggle navigation" aria-controls="navbar-content">
          <span class="fa fa-bars"></span>
        </button>
        <a class="navbar-brand logo-hover" routerLink="/"><img loading="lazy" decoding="async"
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/images/new-theme/logo.webp"
            alt="Raisoni Education"></a>
      </div>

      <app-academic-navigation></app-academic-navigation>

      <div class="main-navbar collapse navbar-collapse navbar-sidebar" id="navbar-content">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item dropdown" routerLinkActive #aboutActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">

            <a class="dropdown-toggle nav-link" [class.active]="aboutActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown">
              About </a>

            <ul class="dropdown-menu fade-down dropdown-menu-1">
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/about/overview">Overview</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/about/about-raisoni-education">About Raisoni
                  Education</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/about/vision-mission">Vision Mission</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/about/leadership">Leadership</a></li>
              <li><a class="dropdown-item" (click)="closeNavbar()" href="https://raisoni.net/institute-list"
                  target="_blank">Institute List</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/about/approvals-accreditation">Approvals &
                  Accreditation</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/about/governance-grievance-policies-guidelines">Governance, Grievance,
                  Policies & Guidelines</a></li>
                     <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                 href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/pdf/mandatory-disclosure-final-25-26.pdf" target="_blank">Mandatory Disclosure A.Y. 2025-26</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown" routerLinkActive #admissionActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">

            <a class="dropdown-toggle nav-link" [class.active]="admissionActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown">
              Admission </a>

            <ul class="dropdown-menu fade-down">
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/admissions/admission-overview">Overview</a></li>

              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/admissions/admission-helpline">Admission Helpline</a></li>

              <!-- <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/admissions/city-office">City Office</a></li> -->

              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/admissions/faq">FAQs</a></li>

              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/admissions/fees-payment">Fee Payment</a></li>

              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/admissions/admission-policies-documents">Admission Policies & Documents</a></li>
                  
      <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
     routerLink="/admissions/advertisement">Advertisement</a></li>
      <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
   routerLink="/admissions/acap-il-merit-list">ACAP / IL merit list</a></li>
       <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
   routerLink="/admissions/acap-vacancy">ACAP / IL Vacancy</a></li>


            </ul>
          </li>
          <li class="nav-item dropdown" routerLinkActive #researchActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">
            <a class="dropdown-toggle  nav-link" [class.active]="researchActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown"> Research </a>
            <ul class="dropdown-menu fade-down">
              <li><a class="dropdown-item" (click)="closeNavbar()" routerLinkActive="active"
                  routerLink="/research/iii-cell">III Cell</a></li>
              <li><a class="dropdown-item" (click)="closeNavbar()" routerLinkActive="active"
                  routerLink="/research/r-and-d">R & D</a></li>
            </ul>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" (click)="closeNavbar()"
              routerLink="/career-and-placements">Career and Placements</a>
          </li>

          <li class="nav-item dropdown" routerLinkActive #campusLifeActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">
            <a class="dropdown-toggle nav-link" [class.active]="campusLifeActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown">
              Campus Life
            </a>
            <ul class="dropdown-menu fade-down">
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/campus-life/hostel">Hostel</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/blogs">Blogs</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  routerLink="/campus-life/facilities-infrastructure">Facilities & Infrastructure</a></li>
              <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                  href="https://yuvacareer.com/" target="_blank">Yuva Career Link</a></li>
            </ul>
          </li>
          <li class="nav-item dropdown" routerLinkActive #academicActive="routerLinkActive"
            [routerLinkActiveOptions]="{ exact: false }">
            <a class="dropdown-toggle nav-link" [class.active]="academicActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown">
             Academics
            </a>
            <ul class="dropdown-menu fade-down">

                        <!-- <li>
                            <a class="dropdown-item"
                              [class.active]="(academicsActiveSection$ | async) === 'dean-message'"
                              (click)="closeNavbar()" [routerLink]="['/academics']" fragment="dean-message">
                              Dean Academics Message
                            </a>
                          </li> -->

                        <!-- <li>
                          <a class="dropdown-item" [class.active]="(academicsActiveSection$ | async) === 'calendar'"
                            (click)="closeNavbar()" [routerLink]="['/academics']" fragment="calendar">
                            Academic Calendar
                          </a>
                        </li> -->

                        <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                            routerLink="/academics/academics-details"> Academics Details</a></li>

                        <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                            routerLink="/academics/academic-calendar"> Academic Calendar</a></li>

                        <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                            routerLink="/academics/examination-cell"> Examination Cell</a></li>

                        <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                            routerLink="/academics/digital-learning"> Digital Learning</a></li>

                        <!-- <li>
                            <a class="dropdown-item" [class.active]="(academicsActiveSection$ | async) === 'usp'"
                              (click)="closeNavbar()" [routerLink]="['/academics']" fragment="usp">
                              Academic USP
                            </a>
                          </li> -->

                          <!-- <li>
                            <a class="dropdown-item"
                              [class.active]="(academicsActiveSection$ | async) === 'digital-learning'"
                              (click)="closeNavbar()" [routerLink]="['/academics']" fragment="digital-learning">
                              Digital Learning
                            </a>
                          </li> -->

                        <!-- <li>
                          <a class="dropdown-item" (click)="closeNavbar()"
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/pdf/updated-toppers-award-23_24.pdf"
                            target="_blank">
                            Topper's List
                          </a>
                        </li> -->

                        <!-- <li>
                          <a class="dropdown-item" [class.active]="(academicsActiveSection$ | async) === 'rules'"
                            (click)="closeNavbar()" [routerLink]="['/academics']" fragment="rules">
                            Academic Rules & Regulations
                          </a>
                        </li> -->

                        <!-- <li>
                          <a class="dropdown-item" [class.active]="(academicsActiveSection$ | async) === 'smart'"
                            (click)="closeNavbar()" [routerLink]="['/academics']" fragment="smart">
                            Smart Class Room
                          </a>
                        </li> -->

                        <!-- <li>
                          <a class="dropdown-item" [class.active]="(academicsActiveSection$ | async) === 'report'"
                            (click)="closeNavbar()" [routerLink]="['/academics']" fragment="report">
                            Annual Report
                          </a>
                        </li> -->

                        <!-- <li>
                            <a class="dropdown-item" [class.active]="(academicsActiveSection$ | async) === 'peer'"
                              (click)="closeNavbar()" [routerLink]="['/academics']" fragment="peer">
                              Peer Teaching
                            </a>
                          </li> -->

                        <!-- <li>
                            <a class="dropdown-item" [class.active]="(academicsActiveSection$ | async) === 'value'"
                              (click)="closeNavbar()" [routerLink]="['/academics']" fragment="value">
                              Value Added / Skill Development Courses
                            </a>
                          </li> -->


            </ul>
          </li>

          <!-- <li class="nav-item dropdown dropdown-mega position-static" routerLinkActive
            #departmentActive="routerLinkActive" [routerLinkActiveOptions]="{ exact: false }">

            <a class="dropdown-toggle nav-link" [class.active]="departmentActive.isActive" href="#"
              data-bs-toggle="dropdown" data-bs-auto-close="outside">
              Department
            </a>

            <div class="dropdown-menu">
              <div class="mega-content">
                <div class="container-fluid">
                  <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3">


                    <div class="col">
                      <ul>
                        <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            routerLink="/courses/first-year-engineering" (click)="closeNavbar()">
                            First Year
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active" routerLink="/courses/computer-engineering"
                            (click)="closeNavbar()">
                            Computer Engineering
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            routerLink="/courses/information-technology" (click)="closeNavbar()">
                            Information Technology
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            routerLink="/courses/electronics-and-telecommunication" (click)="closeNavbar()">
                            Electronics & Telecommunication
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            routerLink="/courses/mechanical-engineering" (click)="closeNavbar()">
                            Mechanical Engineering
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active" routerLink="/courses/civil-engineering"
                            (click)="closeNavbar()">
                            Civil Engineering
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div class="col">
                      <ul>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            routerLink="/courses/artificial-intelligence" (click)="closeNavbar()">
                            CSE (Artificial Intelligence)
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active" routerLink="/courses/data-science"
                            (click)="closeNavbar()">
                            Computer Science & Engineering
                            (Data Science & Cyber Security)
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            routerLink="/courses/cse-ai-machine-learning" (click)="closeNavbar()">
                            CSE (Artificial Intelligence & Machine Learning)
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            routerLink="/courses/electrical-engineering" (click)="closeNavbar()">
                            Electrical Engineering
                          </a>
                        </li>

                      </ul>
                    </div>


                    <div class="col">
                      <ul>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            routerLink="/courses/masters-computer-application" (click)="closeNavbar()">
                            MCA
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            routerLink="/courses/master-business-administration" (click)="closeNavbar()">
                            MBA
                          </a>
                        </li>

                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </li> -->

          <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" (click)="closeNavbar()" routerLink="/events"> Events</a>
          </li>

          <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" (click)="closeNavbar()" routerLink="/contact">Contact</a>
          </li>

          <li class="nav-item dropdown dropdown-mega position-static humbergar-menu" routerLinkActive
            #humbergarActive="routerLinkActive" [routerLinkActiveOptions]="{ exact: false }">

            <a class="dropdown-toggle nav-link" [class.active]="humbergarActive.isActive" href="Javascript:void(0);"
              data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"
              aria-label="More navigation options">
              <i class="fa fa-bars"></i>
            </a>

            <div class="dropdown-menu dropdown-menu-end">
              <div class="mega-content">
                <div class="container-fluid">
                  <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">

                    <div class="col">
                      <h6>Committees</h6>
                      <ul>
                        <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                            routerLink="/committees/governing-body"> Governing Body</a></li>

                        <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                            routerLink="/committees/academic-council">  Academic Council</a></li>

                          <li>
                          <a class="dropdown-item" routerLinkActive="active"
                            [class.active]="(committeesActiveSection$ | async) === 'committee-details'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="committee-details">
                            All committees
                          </a>
                        </li>

                        <!-- <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'anti-ragging'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="anti-ragging">
                            Anti-Ragging Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" [class.active]="(committeesActiveSection$ | async) === 'iqac'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="iqac">
                            IQAC Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'grievance-redressal-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']"
                            fragment="grievance-redressal-committee">
                            Grievance Redressal Committee
                          </a>
                        </li> -->


                        <!-- <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'academic-monitoring-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']"
                            fragment="academic-monitoring-committee">
                            Academic Monitoring Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'institute-website-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']"
                            fragment="institute-website-committee">
                            Institute Website Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" [class.active]="(committeesActiveSection$ | async) === 'iiic'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="iiic">
                            Industry Institute Interaction Cell (IIIC)
                          </a>
                        </li>



                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'internal-complaint-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']"
                            fragment="internal-complaint-committee">
                            Internal Complaint Committee
                          </a>
                        </li>



                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'balance-sheet'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="balance-sheet">
                            Balance Sheet
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'finance-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="finance-committee">
                            Finance Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'college-development-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']"
                            fragment="college-development-committee">
                            College Development Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'minority-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="minority-committee">
                            Minority Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'obc-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="obc-committee">
                            Equal Opportunity Cell
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" [class.active]="(committeesActiveSection$ | async) === 'sc-st-cell'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="sc-st-cell">
                            SC-ST Cell
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'exam-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="exam-committee">
                            Exam Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'student-cell'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="student-cell">
                            Student Cell
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'library-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="library-committee">
                            Library Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'cybervidya-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']"
                            fragment="cybervidya-committee">
                            MIS Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'training-placement-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']"
                            fragment="training-placement-committee">
                            Training &amp; Placement Committee
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'alumni-association-cell'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']"
                            fragment="alumni-association-cell">
                            Alumni Association Cell
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item" [class.active]="(committeesActiveSection$ | async) === 'rd-cell'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="rd-cell">
                            R &amp; D Cell
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'research-advisory-committee'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']"
                            fragment="research-advisory-committee">
                            Research Advisory Committee (RAC)
                          </a>
                        </li>

                        <li>
                          <a class="dropdown-item"
                            [class.active]="(committeesActiveSection$ | async) === 'divyang-cell'"
                            (click)="closeNavbar()" [routerLink]="['/committees/all-committees']" fragment="divyang-cell">
                            Divyang Cell Committee
                          </a>
                        </li> -->

                      </ul>
                    </div>
                    <div class="col">
                      <h6>Student Activities</h6>
                      <ul>
                        <li><a class="dropdown-item"
                            [class.active]="(studentsActivityPortalActiveSection$ | async) === 'dean-message'"
                            (click)="closeNavbar()" [routerLink]="['/students-activity-portal']"
                            fragment="dean-message">Dean Student Welfare Message</a></li>
                        <!-- <li><a class="dropdown-item" (click)="closeNavbar()"
                            href="https://ghrcem.raisoni.net/ieee-student-branch/" target="_blank">IEEE GHRCEM Student
                            Branch</a></li> -->
                        <li><a class="dropdown-item"
                            [class.active]="(studentsActivityPortalActiveSection$ | async) === 'co-curricular'"
                            (click)="closeNavbar()" [routerLink]="['/students-activity-portal']"
                            fragment="co-curricular">Co-curricular Activity</a></li>
                        <li><a class="dropdown-item"
                            [class.active]="(studentsActivityPortalActiveSection$ | async) === 'report'"
                            (click)="closeNavbar()" [routerLink]="['/students-activity-portal']"
                            fragment="report">Activity Report</a></li>
                        <li><a class="dropdown-item"
                            [class.active]="(studentsActivityPortalActiveSection$ | async) === 'extra-curricular'"
                            (click)="closeNavbar()" [routerLink]="['/students-activity-portal']"
                            fragment="extra-curricular">Extra Curricular Activity</a></li>
                        <li><a class="dropdown-item"
                            [class.active]="(studentsActivityPortalActiveSection$ | async) === 'clubs'"
                            (click)="closeNavbar()" [routerLink]="['/students-activity-portal']" fragment="clubs">Club
                            Information</a></li>
                           <!--  <li>
                          <a class="dropdown-item"
                            [class.active]="(studentsActivityPortalActiveSection$ | async) === null"
                            (click)="closeNavbar()" [routerLink]="['/students-activity-portal']">
                            All Student Activities
                          </a>
                        </li> -->
                        <li><a class="dropdown-item"
                            [class.active]="(studentsActivityPortalActiveSection$ | async) === 'sports'"
                            (click)="closeNavbar()" [routerLink]="['/students-activity-portal']" fragment="sports">Sport
                            Activity</a></li>
                             <!-- <li><a class="dropdown-item"
                            [class.active]="(studentsActivityPortalActiveSection$ | async) === 'students-activity-portal'"
                            (click)="closeNavbar()" [routerLink]="['/students-activity-portal']"
                            fragment="students-activity-portal">View All <i class="fa-solid ps-2 fa-arrow-right primary-orange"></i></a></li> -->
                      </ul>
                    </div>
                    <div class="col">
                      <h6>Resources</h6>
                      <ul>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLinkActive="active"
                            routerLink="/nirf">NIRF</a></li>
                        <!-- <li><a class="dropdown-item" (click)="closeNavbar()" routerLinkActive="active"
                            routerLink="/academics">Academics</a></li> -->
                        <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                            href="https://script.google.com/macros/s/AKfycbzbSA3lYjRsPtHPdQoQw8mhJNWsUdYCDvx6E-S7YcJpoIwt5jSVEixk8VTHNPyuhviwFQ/exec"
                            target="_blank">Current Openings</a></li>
                        <li><a class="dropdown-item" routerLinkActive="active" (click)="closeNavbar()"
                            href="https://raisoni.net/raisoni-privilege" target="_blank">Raisoni Privilege</a></li>


                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
